var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animation"},[(_vm.defaultOptions.animationData)?_c('lottie',{attrs:{"options":_vm.defaultOptions},on:{"animCreated":_vm.handleAnimation}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }